import Script from 'next/script';
import { SNAPCHAT_PIXEL_ID } from '@features/Analytics/constants';
export const SnapchatPixel = () => <Script id="snapchat-pixel" data-sentry-element="Script" data-sentry-component="SnapchatPixel" data-sentry-source-file="index.tsx">
    {`(function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function(){
a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
a.queue=[];var s='script';var r=t.createElement(s);r.async=!0;
r.src=n;var u=t.getElementsByTagName(s)[0];
u.parentNode.insertBefore(r,u);})(window,document,'https://sc-static.net/scevent.min.js');
snaptr('init', '${SNAPCHAT_PIXEL_ID}');
snaptr('track', 'PAGE_VIEW');`}
  </Script>;